module.exports = __webpack_public_path__ + "img/btn_self_proclaim.c2ad3972.svg";